import styled from 'styled-components';

export const StyledDashboardPage = styled.div`
  display: flex;
  padding: 22px;
  height: calc(100% - 60px);
  position: relative;
`;

export const StyledWidgetWrapper = styled.div`
  display: flex;
  gap: 10px;
`;
